import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import FearlessCustomMarkup from "../../../../src/content/fearless-scripture-cards/customMarkup";
import FearlessCustomConfirmation from "../../../../src/content/fearless-scripture-cards/customConfirmation";
import * as React from 'react';
export default {
  NewNamesForm,
  FearlessCustomMarkup,
  FearlessCustomConfirmation,
  React
};